// checkbox, select 용
export const BRAND_CHECKBOX_LIST = [
  { label: '전체', name: 'chKEntireBrand', value: 'EntireBrand' },
  { label: 'BMW', name: 'chKBMW', value: 'BMW' },
  { label: 'DS', name: 'chKDS', value: 'DS' },
  { label: '기아', name: 'chKKia', value: 'Kia' },
  { label: '랜드로버', name: 'chKLandrover', value: 'Landrover' },
  { label: '렉서스', name: 'chKLexus', value: 'Lexus' },
  { label: '르노삼성', name: 'chKRenault', value: 'Renault' },
  { label: '링컨', name: 'chKLincoln', value: 'Lincoln' },
  { label: '미니', name: 'chKMini', value: 'Mini' },
  { label: '벤츠', name: 'chKBenz', value: 'Benz' },
  { label: '볼보', name: 'chKVolvo', value: 'Volvo' },
  { label: '쉐보레', name: 'chKChevrolet' },
  { label: '시트로엥', name: 'chKCitroen', value: 'Citroen' },
  { label: '쌍용', name: 'chKSsangyong', value: 'Ssangyong' },
  { label: '아우디', name: 'chKAudi', value: 'Audi' },
  { label: '재규어', name: 'chKJaguar', value: 'Jaguar' },
  { label: '제네시스', name: 'chKGenesis', value: 'Genesis' },
  { label: '지프', name: 'chKJeep', value: 'Jeep' },
  { label: '캐딜락', name: 'chKCadillac', value: 'Cadillac' },
  { label: '테슬라', name: 'chKTesla', value: 'Tesla' },
  { label: '토요타', name: 'chKToyota', value: 'Toyota' },
  { label: '포드', name: 'chKFord', value: 'Ford' },
  { label: '폭스바겐', name: 'chKVolkswagen', value: 'Volkswagen' },
  { label: '푸조', name: 'chKPeugeot', value: 'Peugeot' },
  { label: '현대', name: 'chKHyundai', value: 'Hyundai' },
  { label: '혼다', name: 'chKHonda', value: 'Honda' },
];

// 브랜드 설정 리스트
export const IMPORTED_BRAND = [
  { label: 'BMW', value: 'BMW' },
  { label: 'DS오토모빌', value: 'DS' },
  { label: '람보르기니', value: 'Lamborghini' },
  { label: '랜드로버', value: 'Landrover' },
  { label: '렉서스', value: 'Lexus' },
  { label: '롤스로이스', value: 'RollsRoyce' },
  { label: '링컨', value: 'Lincoln' },
  { label: '마세라티', value: 'Maserati' },
  { label: '멕라렌', value: 'McLaren' },
  { label: '미니', value: 'Mini' },
  { label: '벤츠', value: 'Benz' },
  { label: '벤틀리', value: 'Bentley' },
  { label: '볼보', value: 'Volvo' },
  { label: '시트로엥', value: 'Citroen' },
  { label: '아우디', value: 'Audi' },
  { label: '애스터마틴', value: 'Aston' },
  { label: '재규어', value: 'Jaguar' },
  { label: '지프', value: 'Jeep' },
  { label: '캐딜락', value: 'Cadillac' },
  { label: '테슬라', value: 'Tesla' },
  { label: '토요타', value: 'Toyota' },
  { label: '페라리', value: 'Ferarri' },
  { label: '포드', value: 'Ford' },
  { label: '포르쉐', value: 'Porsche' },
  { label: '폭스바겐', value: 'Volkswagen' },
  { label: '푸조', value: 'Peugeot' },
  { label: '혼다', value: 'Honda' },
];

export const DOMESTIC_BRAND = [
  { label: '기아', value: 'Kia' },
  { label: '르노삼성', value: 'Renault' },
  { label: '쉐보레', value: 'chevrolet' },
  { label: '쌍용', value: 'Ssangyong' },
  { label: '제네시스', value: 'Genesis' },
  { label: '현대', value: 'Hyundai' },
];

/** 쿠키 관련 */
export const LAST_API_TIME = 'lastApiTime';
export const TOKEN = 'token';
export const LOGIN_PHONE = 'loginPhone';
export const COOKIE_OPTIONS = {
  expires: 365,
};

export const WEEK_OPTIONS = [
  {
    label: '전체',
    name: 'ALL',
    id: 0,
  },
  {
    label: '1주차',
    name: 'FIRST_WEEK',
    id: 1,
  },
  {
    label: '2주차',
    name: 'SECOND_WEEK',
    id: 2,
  },
  {
    label: '3주차',
    name: 'THIRD_WEEK',
    id: 3,
  },
  {
    label: '4주차',
    name: 'FOURTH_WEEK',
    id: 4,
  },
  {
    label: '5주차',
    name: 'FIFTH_WEEK',
    id: 5,
  },
  {
    label: '마지막주차',
    name: 'LAST_WEEK',
    id: 6,
  },
];

export const DAY_IDX = {
  전체: 0,
  월: 1,
  화: 2,
  수: 3,
  목: 4,
  금: 5,
  토: 6,
  일: 7,
  공휴일: 8,
};

export const DAY_OPTIONS = [
  {
    label: '전체',
    name: 'ALL',
    id: 0,
  },
  {
    label: '월요일',
    name: 'MONDAY',
    id: 1,
  },
  {
    label: '화요일',
    name: 'TUESDAY',
    id: 2,
  },
  {
    label: '수요일',
    name: 'WEDNESDAY',
    id: 3,
  },
  {
    label: '목요일',
    name: 'THURSDAY',
    id: 4,
  },
  {
    label: '금요일',
    name: 'FRIDAY',
    id: 5,
  },
  {
    label: '토요일',
    name: 'SATURDAY',
    id: 6,
  },
  {
    label: '일요일',
    name: 'SUNDAY',
    id: 7,
  },
  {
    label: '공휴일',
    name: 'HOLIDAY',
    id: 8,
  },
];

/** lead */
export const DISCOUNT_TEXT = '할인가 제안하고 상담 시작하기';
export const RELEASE_SUBMIT_TEXT = '출고 인증하기';
export const RELEASE_COMPLETE_TEXT = '출고 완료하기';
export const RETURN_TEXT = '반환 요청하기';
export const CLOSED_TO_EXPIRED_TITLE = '이용권 만료 임박 안내';
export const CLOSED_TO_EXPIRED_DESCRIPTION =
  '이용권이 곧 만료됩니다. 미리 이용권을 구매해주세요!';
export const EXPIRED_TITLE = '이용권 만료 안내';
export const EXPIRED_DESCRIPTION =
  '이용권이 만료되었습니다. 새로운 이용권을 구매해주세요!';

/** 리드목록 검색영역값 노출 배너에 대한 필드 */
export const SEARCH_BANNER_FIELDS = [
  'KEYWORD',
  'TERM',
  'BRAND',
  'MODEL',
  'BUY_TYPE',
] as const;

/** product */
export const PRODUCTS = {
  CASH_INSTALL_15: {
    name: 'CASH_INSTALL_15',
    text: '현금/할부 15일',
  },
  CASH_INSTALL_30: {
    name: 'CASH_INSTALL_30',
    text: '현금/할부 30일 +3일',
  },
};

export const PRODUCT_USE_STATE = {
  // 미입금
  NOT_PAID: {
    name: 'NOT_PAID',
    subText: '대기',
    mainText: '입금 대기',
  },
  // 입금완료(대기)
  WAIT_PAID_COMPLETE: {
    name: 'WAIT_PAID_COMPLETE',
    subText: '대기',
    mainText: '결제 완료',
  },
  // 입금완료(이용중)
  USING: {
    name: 'USING',
    subText: '이용중',
    mainText: '결제 완료',
  },
  // 입금 완료(종료)
  EXPIRED: {
    name: 'EXPIRED',
    subText: '만료',
    mainText: '결제 완료',
  },
  // 결제 취소(고객취소, 환불완료)
  CANCEL: {
    name: 'CANCEL',
    subText: '취소',
    mainText: '결제 취소',
  },
};

export const RELEASE_CERT_STATUS = {
  ready: '출고 인증',
  sent: '출고 확인 중',
  failed: '출고 인증 다시하기',
};

export const REGISTRATION_STATUS = {
  READY: '출고 인증',
  RETRY_SCHEDULED: '출고 확인 중',
  FAILED: '출고 인증 다시하기',
};

export type ICON = `${ICON_CATEGORY}-${ICON_SIZE}-${ICON_NAME}`;

type ICON_CATEGORY = 'pictogram' | 'brand' | 'partner';
type ICON_SIZE = 'small' | 'regular' | 'large';
type ICON_NAME =
  | 'leadlist_click'
  | 'leadlist_unClick'
  | 'menu-click'
  | 'menu_unClick'
  | 'phone_solic'
  | 'message'
  | 'close'
  | 'checkbox-check'
  | 'checkbox-unCheck'
  | 'ticket'
  | 'filter'
  | 'notice'
  | 'schedule'
  | 'new'
  | 'arrow_header_left'
  | 'arrow_right'
  | 'input_delete';

export const CONSONANT_LIST = [
  '전체',
  'ㄱ',
  'ㄴ',
  'ㄷ',
  'ㄹ',
  'ㅁ',
  'ㅂ',
  'ㅅ',
  'ㅇ',
  'ㅈ',
  'ㅊ',
  'ㅋ',
  'ㅌ',
  'ㅍ',
  'ㅎ',
];

export const CHOSUNG = [
  'ㄱ',
  'ㄲ',
  'ㄴ',
  'ㄷ',
  'ㄸ',
  'ㄹ',
  'ㅁ',
  'ㅂ',
  'ㅃ',
  'ㅅ',
  'ㅆ',
  'ㅇ',
  'ㅈ',
  'ㅉ',
  'ㅊ',
  'ㅋ',
  'ㅌ',
  'ㅍ',
  'ㅎ',
];

export const CDN_URL = 'https://cloud.getcha.io/';
export const DEALER_CDN_URL = 'https://cloud.getcha.io/Dealer_Web/';

export const IMAGE_CDN_URL = 'https://img.getcha.io/';
export const IMAGE_DEALER_CDN_URL = 'https://img.getcha.io/Dealer_Web/';
